export class ClienteModel{
    // codigoAtendimento?: number;
    documento: string;
    nome: string;
    email: string;
    telefone: string;

    genero?: string = null;
    nascimento?: string;
    
    
    endereco?: Endereco = new Endereco();
    dadosComplementares?: any = [];

    tipoCliente?: string;
    consumidor?: any = [];
    codigoExtra?: string;
}

export class Endereco{
    cep: any;
    uf: string;
    cidade: string;
    bairro: string;
    logradouro: string;
    numero: any
    complemento: string;
}


// WEBPACK FOOTER //
// ./src/app/models/ClienteModel.ts